export const deconstructError = (error: any) => {
  const correlationIdentifier = error.response.data.correlationIdentifier ?? undefined;
  const severity = error.response.data.severity ?? undefined;
  const message = error.response.data.title ?? 'Uautoriseret adgang nægtet';
  return { message, severity, correlationIdentifier };
};

export const isAuthError = (error: any) => error.response.data.status === 401 || error.response.data.status === 403;
